import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Modal from '@material-ui/core/Modal';
import GochiTableHead from '../../components/molecules/ChangeTicketGochiTableHead';
import GochiTableBody from '../../components/molecules/ChangeTicketGochiTableBody';
import CouponTableHead from '../../components/molecules/ChangeTicketCouponTableHead';
import CouponTableBody from '../../components/molecules/ChangeTicketCouponTableBody';
// import ExPagination from '../../components/molecules/ExPagination';
import { switchTicketToNonUse } from '../../actions/Gochis';
import { sendLogin } from '../../auth/Auth';
import ChangeTicketToNonUseButton from '../../components/atoms/ChangeTicketToNonUseButton';
import ToSelectMenuButton from '../../components/atoms/ToSelectMenuButton';
import RefundButton from '../../components/atoms/RefundButton';
import ValidationText from '../../components/atoms/ValidationText';
import RefundPopup from '../../components/molecules/RefundPopup';
import paymentTypes from '../../constants/PaymentTypes';
import FullRefundPopup from '../../components/molecules/FullRefundPopup';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  titleText: {
    padding: '16px'
  },
  listBtnRefund: {
    position: 'relative',
    height: '45px'
  },
  btnRefund: {
    position: 'absolute',
    right: '100px'
  },
  btnFullRefund: {
    position: 'absolute',
    right: '0px'
  },
  buttonGroupRight: {
    textAlign: 'right',
    float: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      gochi: state.gochis
    }),
    dispatch => ({
      actions: bindActionCreators({ switchTicketToNonUse }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityId', 'setIdentityId', null),
  withState('shopId', 'setShopId', null),
  withState('sealCertificate', 'setSealCertificate', null),
  withState('businessLicense', 'setBusinessLicense', null),
  withState('other', 'setOther', null),
  withState('note', 'setNote', null),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withState('listCouponId', 'setlistCouponId', []),
  withState('couponSelectError', 'setCouponSelectError', ''),
  withState('openRefundPopup', 'setOpenRefundPopup', false),
  withState('updateOpenRefundPopup', 'setUpdateOpenRefundPopup', false),
  withState('openFullRefundPopup', 'setOpenFullRefundPopup', false),
  withState('updateOpenFullRefundPopup', 'setUpdateOpenFullRefundPopup', false),
  withState('checkRefund', 'updateCheckRefund', false),
  withHandlers({
    handleRedirectOpen: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setlistCouponId([]);
    }
  })
);

const Main = enhance(
  ({
    classes,
    progress,
    gochi,
    handleChangePage,
    roles,
    page,
    totalCount,
    rowsPerPage,
    setTargetRowId,
    listCouponId,
    setlistCouponId,
    handleRedirectOpen,
    actions,
    couponSelectError,
    setCouponSelectError,
    openRefundPopup,
    setOpenRefundPopup,
    setUpdateOpenRefundPopup,
    openFullRefundPopup,
    setUpdateOpenFullRefundPopup,
    checkRefund,
    updateCheckRefund,
    setOpenFullRefundPopup
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const addOrRemove = (array, item) => {
      const exists = array.includes(item);
      let result;
      if (exists) {
        result = array.filter(c => {
          return c !== item;
        });
      } else {
        result = array;
        result.push(item);
      }
      return result;
    };

    const setListCoupon = couponId => {
      const list = addOrRemove(listCouponId, couponId);
      setlistCouponId(list);
    };

    console.log('couponId', listCouponId);

    const menuRedirectAction = () =>
      handleRedirectOpen(
        `/change_ticket_menu?gochiBillId=${gochi.gochiBillId}&firstMenuName=${
          gochi.coupons[0].menuName
        }&firstPrice=${gochi.coupons[0].amount +
          gochi.coupons[0].taxAmount}&firstCouponCount=${
          gochi.couponCount
        }&shopId=${gochi.shopId ? gochi.shopId : ''}&groupId=${
          gochi.groupId ? gochi.groupId : ''
        }`
      );

    const changeNonUseAction = params => {
      console.log('abc', switchTicketToNonUse({ couponIds: params }));
      progress.updateOpenProgress(true);
      actions
        .switchTicketToNonUse({ couponIds: params })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.type === 'CHANGE_TICKE_TO_NON_USE_SUCCESS') {
            alert('チケットを未使用に戻しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    useEffect(() => {
      setlistCouponId([]);
      setUpdateOpenFullRefundPopup(true);
      setCouponSelectError('');
    }, [gochi]);

    const validMenuIdChange = v => {
      const value = v;
      if (!value) {
        setCouponSelectError('チケットを選択してください。');
        return 1;
      }
      setCouponSelectError('');
      return 0;
    };

    function fnPaymentTypes(value) {
      let text = value;
      if (value === paymentTypes.STRIPE.toString()) {
        text = `STRIPE`;
      } else if (value === paymentTypes.PAYPAY.toString()) {
        text = `PAYPAY`;
      } else if (value === paymentTypes.ONEPAY_ALIPAY.toString()) {
        text = `ONEPAY_ALIPAY`;
      } else if (value === paymentTypes.ONEPAY_LINEPAY.toString()) {
        text = `ONEPAY_LINEPAY`;
      } else if (value === paymentTypes.ONEPAY_MERUPAY.toString()) {
        text = `ONEPAY_MERUPAY`;
      } else if (value === paymentTypes.WECHATPAY.toString()) {
        text = `WECHATPAY`;
      } else if (value === paymentTypes.VERITRANS.toString()) {
        text = `VERITRANS`;
      } else if (value === paymentTypes.ATONE.toString()) {
        text = `ATONE`;
      }
      return text;
    }

    const refundOpenAction = () => setOpenRefundPopup(true);
    const fullRefundOpenAction = () => setOpenFullRefundPopup(true);

    let listBtn;
    if (gochi.chargeAmountRemain > 0) {
      listBtn = (
        <div className={classes.listBtnRefund}>
          <div className={classes.btnRefund}>
            <RefundButton
              title="一部返金"
              disabled={checkRefund || gochi.gochiType === 'LOCAL_WALLET'}
              onClickAction={refundOpenAction}
            />
          </div>
          <div className={classes.btnFullRefund}>
            <RefundButton
              title="全部返金"
              disabled={checkRefund || gochi.gochiType === 'LOCAL_WALLET'}
              onClickAction={fullRefundOpenAction}
            />
          </div>
        </div>
      );
    } else {
      listBtn = (
        <div className={classes.listBtnRefund}>
          <div className={classes.btnRefund}>
            <RefundButton
              title="一部返金"
              onClickAction={refundOpenAction}
              disabled="true"
            />
          </div>
          <div className={classes.btnFullRefund}>
            <RefundButton
              title="全部返金"
              disabled="true"
              onClickAction={fullRefundOpenAction}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className={classes.titleText}>
          領収書No：
          {gochi.gochiBillNo}
        </div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiTableHead roles={roles} />
            <GochiTableBody
              gochiBillNo={gochi.gochiBillNo}
              gochiBillId={gochi.gochiBillId}
              shopId={gochi.shopId}
              shopName={gochi.shopName}
              groupId={gochi.groupId}
              groupName={gochi.groupName}
              emailBuy={gochi.emailBuy}
              gochiType={gochi.gochiType}
              gochiUserType={gochi.gochiUserType}
              amount={gochi.amount}
              taxAmount={gochi.taxAmount}
              createdAt={gochi.createdAt}
              couponCount={gochi.couponCount}
              paymentType={
                gochi.paymentDto
                  ? fnPaymentTypes(gochi.paymentDto.paymentType)
                  : ''
              }
              chargeAmount={gochi.chargeAmount}
            />
          </Table>
        </div>
        {listBtn}
        <div className={classes.titleText}>
          対象の領収書No内に複数のごち枚数がある場合、全部にリストアップされる
        </div>
        <ValidationText message={couponSelectError} />
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <CouponTableHead roles={roles} />
            <CouponTableBody
              coupons={gochi.coupons}
              setListCoupon={setListCoupon}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              setTargetRowId={setTargetRowId}
              roles={roles}
            />
          </Table>
        </div>
        <div className={classes.buttonGroupRight}>
          <ToSelectMenuButton
            onClickAction={menuRedirectAction}
            id={gochi.gochiBillId}
            disabled={gochi.menuLimitTotal === 1}
          />
        </div>
        <div className={classes.buttonGroupRight}>
          <ChangeTicketToNonUseButton
            onClickAction={changeNonUseAction}
            numberSelect={listCouponId.length}
            validMenuIdChange={validMenuIdChange}
            params={listCouponId}
          />
        </div>
        <div>
          <Modal open={openRefundPopup}>
            <RefundPopup
              setOpenRefundPopup={setOpenRefundPopup}
              setUpdateOpenRefundPopup={setUpdateOpenRefundPopup}
              updateCheckRefund={updateCheckRefund}
              gochiBillNo={gochi.gochiBillNo}
              gochiBillId={gochi.gochiBillId}
              paymentId={gochi.paymentId}
              merchantPaymentId={
                gochi.paymentDto ? gochi.paymentDto.merchantPaymentId : ''
              }
              paymentType={
                gochi.paymentDto
                  ? fnPaymentTypes(gochi.paymentDto.paymentType)
                  : ''
              }
              chargeAmount={gochi.chargeAmountRemain}
            />
          </Modal>
        </div>
        <div>
          <Modal open={openFullRefundPopup}>
            <FullRefundPopup
              setOpenFullRefundPopup={setOpenFullRefundPopup}
              setUpdateOpenFullRefundPopup={setUpdateOpenFullRefundPopup}
              gochiBillNoo={gochi.gochiBillNo}
              gochiBillIdData={gochi.gochiBillId}
              paymentIdData={gochi.paymentId}
              updateCheckRefund={updateCheckRefund}
              merPaymentId={
                gochi.paymentDto ? gochi.paymentDto.merchantPaymentId : ''
              }
              paymentType={
                gochi.paymentDto
                  ? fnPaymentTypes(gochi.paymentDto.paymentType)
                  : ''
              }
              chargeAmount={gochi.chargeAmountRemain}
            />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
